import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { Link, withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { Link as MaterialLink } from '@material-ui/core';
import Menu from './Menu';
import Button from '@material-ui/core/Button';
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import './Topbar.css';

const styles = (theme) => ({
  appBar: {
    position: 'relative',
    boxShadow: 'none',
    borderBottom: `1px solid ${theme.palette.grey['100']}`,
    backgroundColor: '#EFEFEF',
    width: '100vw',
    zIndex: 9998,
  },
  toolBar: {
    minHeight: 84,
    height: '100%',
    backgroundColor: '#FFFFFF',
    '& .MuiTabs-root': {
      height: '100%',
    },
    '& .MuiTabs-scroller': {
      display: 'flex',
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0px',
    },
  },
  inline: {
    display: 'inline',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      paddingTop: '0.5em',
    },
  },
  flex: {
    width: 1080,
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  logo: {
    paddingTop: '16px',
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
    },
  },
  iconContainer: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  iconButton: {
    float: 'right',
  },
  menuContainer: {
    marginLeft: 32,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  mobileMenuRoot: {
    zIndex: '9999 !important',
  },
  indicator: {
    backgroundColor: theme.palette.primary.main,
  },
  tabItem: {
    textTransform: 'none',
    paddingTop: 20,
    paddingBottom: 20,
    minWidth: 140,
    minHeight: 84,
    fontSize: '1rem',
    color: theme.typography.color,
    fontWeight: 'bold',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  root: {
    display: 'block',
    padding: 0,
  },
  paper: {
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
  },
  mobSubMenu: {
    color: 'rgba(255,255,255)',
    backgroundColor: 'rgba(234,84,4,0.7)',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  expandedAccord: {
    color: theme.palette.primary.main,
  },
});

class Topbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuDrawer: false,
      value: 0,
      expanded: null,
    };
    if (props.ref) {
      props.ref(this);
    }
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  mobileMenuOpen = (event) => {
    this.setState({ menuDrawer: true });
  };

  mobileMenuClose = (event) => {
    this.setState({ menuDrawer: false });
  };
  toggleMenu = (event, param) => {
    this.setState({ expanded: param });
  };
  componentDidMount() {}

  componentWillUnmount() {}

  current = () => {
    const currentPath = this.props.currentPath;

    if (currentPath.indexOf('/main') > -1) {
      return 0;
    }
    if (currentPath.indexOf('/about') > -1) {
      //console.log('/about', currentPath.indexOf('/about'));
      return 1;
    }
    if (currentPath.indexOf('/business') > -1) {
      //console.log('/business', currentPath.indexOf('/business'));
      return 2;
    }
    if (currentPath.indexOf('/project') > -1) {
      //console.log('/project', currentPath.indexOf('/project'));
      return 3;
    }
    if (currentPath.indexOf('/contact') > -1) {
      //console.log('/contact', currentPath.indexOf('/contact'));
      return 4;
    }
  };

  render() {
    const { classes } = this.props;
    const { expanded } = this.state;
    return (
      <AppBar position="static" color="default" className={classes.appBar} id="appbar">
        <Toolbar className={classes.toolBar}>
          <Grid container spacing={0} justify="center" alignItems="baseline">
            <Grid className={classes.flex}>
              <div className={classes.inline}>
                <Link to="/" className={classes.link}>
                  <img src="images/innon_logo@2x.png" alt="innon_logo" className={classes.logo} />
                </Link>
              </div>
              {!this.props.noTabs && (
                <React.Fragment>
                  <div className={classes.menuContainer}>
                    <SwipeableDrawer
                      anchor="right"
                      open={this.state.menuDrawer}
                      onClose={this.mobileMenuClose}
                      onOpen={this.mobileMenuOpen}
                      classes={{
                        root: classes.mobileMenuRoot,
                      }}
                    >
                      <AppBar title="Menu" />
                      <List
                        style={{ width: '100%', height: '100vh', backgroundColor: 'rgba(0,0,0,0.9)', color: '#fff', padding: '0 20px' }}
                      >
                        <Grid container justify="flex-end" style={{ paddingTop: 20 }}>
                          <IconButton
                            onClick={() => {
                              this.setState({ menuDrawer: false });
                            }}
                          >
                            <CloseIcon style={{ color: '#fff' }} />
                          </IconButton>
                        </Grid>

                        {Menu.map((item, index) => (
                          <div key={`menu-div-${index}`} style={{ borderBottom: '1px solid #464646' }}>
                            <Accordion
                              square={true}
                              expanded={expanded === `panel${index}`}
                              onChange={(e) => this.toggleMenu(e, `panel${index}`)}
                              style={{ backgroundColor: 'transparent', color: '#fff' }}
                            >
                              <AccordionSummary
                                aria-controls="panel1d-content"
                                id="panel1d-header"
                                classes={{ expanded: classes.expandedAccord }}
                                style={!item.display ? { display: 'none' } : {}}
                              >
                                <Typography>{item.label}</Typography>
                              </AccordionSummary>
                              <AccordionDetails className={classes.root}>
                                {item.children &&
                                  item.children.map((children, idx) => {
                                    return (
                                      <ListItem
                                        button
                                        component={children.external ? MaterialLink : Link}
                                        href={children.external ? children.pathname : null}
                                        to={
                                          children.external
                                            ? null
                                            : item.label === 'Project'
                                            ? {
                                                pathname: children.pathname,
                                                search: this.props.location.search,
                                                state: {
                                                  tabClicked: true,
                                                },
                                              }
                                            : {
                                                pathname: children.pathname,
                                                search: this.props.location.search,
                                              }
                                        }
                                        onClick={() => {
                                          if (item.label === 'Project') {
                                            sessionStorage.setItem('isTopbarClick', true);
                                            sessionStorage.setItem('isTabClick', false);
                                          }
                                        }}
                                        key={children.label}
                                        classes={{ button: classes.mobSubMenu }}
                                      >
                                        <ListItemText primary={children.label} />
                                      </ListItem>
                                    );
                                  })}
                              </AccordionDetails>
                            </Accordion>
                          </div>
                          // <>
                          //   <ListItem
                          //     component={item.external ? MaterialLink : Link}
                          //     href={item.external ? item.pathname : null}
                          //     to={
                          //       item.external
                          //         ? null
                          //         : {
                          //             pathname: item.pathname,
                          //             search: this.props.location.search,
                          //           }
                          //     }
                          //     button
                          //     key={item.label}
                          //   >
                          //     <ListItemText primary={item.label} />
                          //   </ListItem>
                          //   {item.children.map((children, idx) => {
                          //     return (
                          //       <ListItem
                          //         component={item.external ? MaterialLink : Link}
                          //         href={item.external ? item.pathname : null}
                          //         to={
                          //           item.external
                          //             ? null
                          //             : {
                          //                 pathname: item.pathname,
                          //                 search: this.props.location.search,
                          //               }
                          //         }
                          //         button
                          //         key={`subMenu-${idx}`}
                          //       >
                          //         <ListItemText primary={children.label} />
                          //       </ListItem>
                          //     );
                          //   })}
                          // </>
                        ))}
                      </List>
                    </SwipeableDrawer>
                    <div className="tabContainer">
                      <Tabs
                        value={this.current() || this.state.value}
                        // indicatorColor="primary"
                        textColor="primary"
                        classes={{
                          indicator: classes.indicator,
                        }}
                        onChange={this.handleChange}
                      >
                        {Menu.map((item, index) => (
                          <Tab
                            key={index}
                            component={item.external ? MaterialLink : Link}
                            href={item.external ? item.pathname : null}
                            to={
                              item.external
                                ? null
                                : {
                                    pathname: item.pathname,
                                  }
                            }
                            classes={{ root: classes.tabItem }}
                            label={item.label}
                            style={!item.display ? { display: 'none' } : {}}
                          />
                        ))}
                      </Tabs>

                      <div className={'sub-menu'}>
                        <Grid container justify="flex-end" style={{ width: 1080 }}>
                          {Menu.map((item, index) => {
                            if (item.display) {
                              return (
                                <ul key={item.label} style={{ width: 140 }}>
                                  {item.children.map((menu, idx) => {
                                    if (menu.display) {
                                      return (
                                        <li
                                          onClick={() => {
                                            if (item.label === 'Project') {
                                              this.props.history.push({
                                                pathname: menu.pathname,
                                                state: {
                                                  tabClicked: true,
                                                },
                                              });
                                              sessionStorage.setItem('isTopbarClick', true);
                                              sessionStorage.setItem('isTabClick', false);
                                            } else {
                                              this.props.history.push(menu.pathname);
                                            }
                                          }}
                                          key={`drawer-menu-${menu.label}`}
                                        >
                                          {menu.label}
                                        </li>
                                      );
                                    }
                                  })}
                                </ul>
                              );
                            }
                          })}
                        </Grid>
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              )}
              <div className={classes.iconContainer}>
                <IconButton
                  onClick={this.mobileMenuOpen}
                  style={
                    this.state.pathname === 'mypage' || this.state.pathname === 'profile' || this.state.pathname === 'main'
                      ? { color: '#fff' }
                      : { color: '#555' }
                  }
                  className={classes.iconButton}
                  aria-label="Menus"
                >
                  <MenuIcon style={{ width: '1.1em !important', height: '1.1em' }} />
                </IconButton>
              </div>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(Topbar));
